// extracted by mini-css-extract-plugin
module.exports = {"container":"panel_container__14jdY","header":"panel_header__36A3c"};